/**
 * Do not edit directly
 */

export default "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJhIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij48cGF0aCBkPSJtNy45OSwybDMuNTEsMTBoLTEuOTRsLS42Ni0yLjFoLTMuOGwtLjY2LDIuMWgtMS45NEw2LjAxLDJoMS45OFptLS45OSwxLjhsLTEuNDEsNC41MWgyLjgxbC0xLjQtNC41MVoiIHN0eWxlPSJzdHJva2Utd2lkdGg6MHB4OyIvPjwvc3ZnPg==";